<template>
  <v-row justify="center" align-content="center" class="no-data">
    <v-col sm="6" class="text-center">
      <h3 class="mb-3">{{ title }}</h3>
      <p>{{ description }}</p>
      <v-btn color="primary" :to="{ name: buttonRouteName }">
        <v-icon small>icon-plus</v-icon>{{ buttonName }}
      </v-btn>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "NoDataInfo",
  props: {
    title: {
      type: String,
      required: true
    },
    description: {
      type: String,
      required: true
    },
    buttonName: {
      type: String,
      required: true
    },
    buttonRouteName: {
      type: String,
      default: ""
    }
  }
};
</script>

<style lang="scss" scoped>
.no-data {
  height: 100%;
}
</style>
